import React from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import Swal from "sweetalert2";
import { useAuth, ROLES, MODULES, ROLE_LABELS } from "../context/AuthContext";

const SideNav = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { user, loading, hasModuleAccess, isSuperAdmin } = useAuth();

  const token = localStorage.getItem("token");
  const adminName = user?.name || "";

  const handleLogout = (e) => {
    e.preventDefault();
    Swal.fire({
      title: "Are you sure?",
      text: "You will be logged out!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, logout!",
    }).then((result) => {
      if (result.isConfirmed) {
        localStorage.removeItem("token");
        navigate("/login");
        toast.success("You have been logged out!");
      }
    });
  };

  const isActive = (path) => {
    if (path === "/") {
      return location.pathname === "/";
    } else {
      return location.pathname.startsWith(path);
    }
  };

  const getRoleBadgeClass = (role) => {
    switch (role) {
      case ROLES.SUPER_ADMIN:
        return "badge badge-danger";
      case ROLES.SUB_ADMIN:
        return "badge badge-primary";
      default:
        return "badge badge-light";
    }
  };

  return (
    <div>
      <aside className="main-sidebar sidebar-dark-primary elevation-4">
        <div className="sidebar">
          <div className="user-panel mt-3 pb-3 mb-3 d-flex">
            <div className="image"></div>
            <Link to="/admin-view" className="info">
              <div className="d-block" style={{ color: "white" }}>
                {adminName}
              </div>
            </Link>
          </div>

          <nav className="mt-2">
            <ul
              className="nav nav-pills nav-sidebar flex-column"
              data-widget="treeview"
              role="menu"
              data-accordion="false"
            >
              {token && (
                <>
                  {/* Dashboard - check module access */}
                  {(!loading && hasModuleAccess(MODULES.DASHBOARD)) && (
                    <>
                      <li className="nav-item menu-open">
                        <Link
                          to="/dashboard"
                          className={`nav-link ${isActive("/dashboard") ? "active" : ""
                            }`}
                        >
                          <i className="nav-icon fas fa fa-dashboard"></i>
                          <p>Dashboard</p>
                        </Link>
                      </li>
                      <br />
                    </>
                  )}


                  {(!loading && hasModuleAccess(MODULES.INQUIRY_MANAGEMENT)) && (
                    <>
                      <li className="nav-item menu-open">
                        <Link
                          to="/inquiry"
                          className={`nav-link ${isActive("/inquiry") ? "active" : ""
                            }`}
                        >
                          <i className="nav-icon fas fa-user"></i>
                          <p>Inquiry Management</p>
                        </Link>
                      </li>
                      <br />
                    </>
                  )}

                  {(!loading && hasModuleAccess(MODULES.WALLET_MANAGEMENT)) && (
                    <>
                      <li className="nav-item menu-open">
                        <Link
                          to="/users"
                          className={`nav-link ${isActive("/users") ? "active" : ""
                            }`}
                        >
                          <i className="nav-icon fas fa-user"></i>
                          <p>Wallet Management</p>
                        </Link>
                      </li>
                      <br />
                    </>
                  )}

                  {(!loading && hasModuleAccess(MODULES.MERCHANT_MANAGEMENT)) && (
                    <>
                      <li className="nav-item menu-open">
                        <Link
                          to="/merchants"
                          className={`nav-link ${isActive("/merchants") ? "active" : ""
                            }`}
                        >
                          <i className="nav-icon fas fa-business-time"></i>
                          <p>Merchant Management</p>
                        </Link>
                      </li>
                      <br />
                    </>
                  )}

                  {(!loading && hasModuleAccess(MODULES.TRANSACTION_MONITORING)) && (
                    <>
                      <li className="nav-item menu-open">
                        <Link
                          to="/transaction"
                          className={`nav-link ${isActive("/transaction") ? "active" : ""
                            }`}
                        >
                          <i className="nav-icon fas fa-tachometer-alt"></i>
                          <p>Transaction Monitoring</p>
                        </Link>
                      </li>
                      <br />
                    </>
                  )}

                  {(!loading && hasModuleAccess(MODULES.USER_WITHDRAWALS)) && (
                    <>
                      <li className="nav-item menu-open">
                        <Link
                          to="/user-withdrawals"
                          className={`nav-link ${isActive("/user-withdrawals") ? "active" : ""
                            }`}
                        >
                          <i className="nav-icon fas fa-wallet"></i>
                          <p>User Withdrawals</p>
                        </Link>
                      </li>
                      <br />
                    </>
                  )}

                  {(!loading && hasModuleAccess(MODULES.FIAT_TRANSACTIONS)) && (
                    <>
                      <li className="nav-item menu-open">
                        <Link
                          to="/fiat-transaction"
                          className={`nav-link ${isActive("/fiat-transaction") ? "active" : ""
                            }`}
                        >
                          <i className="nav-icon fas fa-tachometer-alt"></i>
                          <p>Fiat Transactions</p>
                        </Link>
                      </li>
                      <br />
                    </>
                  )}

                  {(!loading && hasModuleAccess(MODULES.PAYMENT_MANAGEMENT)) && (
                    <>
                      <li className="nav-item menu-open">
                        <Link
                          to="/payment-management"
                          className={`nav-link ${isActive("/payment-management") ? "active" : ""
                            }`}
                        >
                          <i className="nav-icon fas fa-tachometer-alt"></i>
                          <p>Payment Management</p>
                        </Link>
                      </li>
                      <br />
                    </>
                  )}

                  {(!loading && hasModuleAccess(MODULES.CONTACT_US)) && (
                    <>
                      <li className="nav-item menu-open">
                        <Link
                          to="/contact-us"
                          className={`nav-link ${isActive("/contact-us") ? "active" : ""
                            }`}
                        >
                          <i className="nav-icon fas fa-folder"></i>
                          <p>Merchant Support</p>
                        </Link>
                      </li>
                      <br />
                    </>
                  )}

                  {(!loading && hasModuleAccess(MODULES.CUSTOMER_SUPPORT)) && (
                    <>
                      <li className="nav-item menu-open">
                        <Link
                          to="/customer-support"
                          className={`nav-link ${isActive("/customer-support") ? "active" : ""
                            }`}
                        >
                          <i className="nav-icon fas fa-folder"></i>
                          <p>Customer Support</p>
                        </Link>
                      </li>
                      <br />
                    </>
                  )}

                  {(!loading && hasModuleAccess(MODULES.FAQ_MANAGEMENT)) && (
                    <>
                      <li className="nav-item menu-open">
                        <Link
                          to="/faq"
                          className={`nav-link ${isActive("/faq") ? "active" : ""}`}
                        >
                          <i className="nav-icon fas fa-comments"></i>
                          <p>FAQ Management</p>
                        </Link>
                      </li>
                      <br />
                    </>
                  )}

                  {(!loading && hasModuleAccess(MODULES.CONTENT_MANAGEMENT)) && (
                    <>
                      <li className="nav-item menu-open">
                        <Link
                          to="/content-management"
                          className={`nav-link ${isActive("/content-management") ? "active" : ""
                            }`}
                        >
                          <i className="nav-icon fas fa-folder"></i>
                          <p>Content Management</p>
                        </Link>
                      </li>
                      <br />
                    </>
                  )}

                  {(!loading && hasModuleAccess(MODULES.NOTIFICATION)) && (
                    <>
                      <li className="nav-item menu-open">
                        <Link
                          to="/notification-management"
                          className={`nav-link ${isActive("/notification-management") ? "active" : ""
                            }`}
                        >
                          <i className="nav-icon fas fa fa-bell"></i>
                          <p>Notification</p>
                        </Link>
                      </li>
                      <br />
                    </>
                  )}

                  {/* Admin Management - Super Admin Only */}
                  {(!loading && isSuperAdmin()) && (
                    <>
                      <li className="nav-item menu-open">
                        <Link
                          to="/admin-management"
                          className={`nav-link ${isActive("/admin-management") ? "active" : ""
                            }`}
                        >
                          <i className="nav-icon fas fa-user-shield"></i>
                          <p>Admin Management</p>
                        </Link>
                      </li>
                      <br />
                    </>
                  )}

                  <li className="nav-item menu-open">
                    <a
                      href="/logout"
                      className="nav-link"
                      onClick={handleLogout}
                    >
                      <i className="" />
                      <i className="nav-icon fas fa-sign-out-alt"></i>
                      <p>Logout</p>
                    </a>
                  </li>
                </>
              )}
            </ul>
          </nav>
        </div>
      </aside>
    </div>
  );
};

export default SideNav;
